module.exports = __webpack_public_path__ + "img/redcross.d49f7f37.svg";